// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeAvailableFunction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { FUNCTION } from './Izenda.ReportPartFieldConstants';
import { CHART_TYPE } from 'logic/data/Izenda.ChartDefaultConfig';

const availableSeparator = {
  SUPPORTED: {
    Datetime: [FUNCTION.GROUP, FUNCTION.GROUP_DAYS_OLD],
    DEFAULT: [FUNCTION.GROUP]
  }
};

const groupFunctions = [FUNCTION.GROUP, FUNCTION.GROUP_DAYS_OLD];

const AVAILABLE_FUNCTION_CONFIG = {};

/* Solid Gauge, Linear Gauge, Simple Gauge */
AVAILABLE_FUNCTION_CONFIG[CHART_TYPE.SolidGauge] = AVAILABLE_FUNCTION_CONFIG[
  CHART_TYPE.SolidGauge
] = AVAILABLE_FUNCTION_CONFIG[CHART_TYPE.SolidGauge] = {
  values: {
    UNSUPPORTED: {
      DEFAULT: groupFunctions
    }
  },
  threshold: {
    // same as values
    UNSUPPORTED: {
      DEFAULT: groupFunctions
    }
  },
  separators: availableSeparator
};

export default {
  AVAILABLE_FUNCTION_CONFIG
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.GaugeAvailableFunction.js